var map = {
	"./accel.svg": "61fd",
	"./barometer.svg": "7b55",
	"./digital.svg": "8cd3",
	"./gauge.svg": "251c",
	"./gps.svg": "33a5",
	"./humidity.svg": "cd8b",
	"./illuminance.svg": "8505",
	"./percentage.svg": "c3bb",
	"./switch-off.svg": "a9ef",
	"./switch-on.svg": "7cc5",
	"./temp.svg": "0131",
	"./time.svg": "ddca",
	"./voltage.svg": "ffb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea58";